import { render, staticRenderFns } from "./EditFornecedor.vue?vue&type=template&id=c18bff60"
import script from "./EditFornecedor.vue?vue&type=script&lang=js"
export * from "./EditFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports